export default __webpack_public_path__ + "static/media/maduro-2Closed.b7201b10.jpg";